import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "../../../config/api";
import { BaseballField } from "../../depth-chart-page/components";

const WIDTH = 1056;
const HEIGHT = 816;

export const DepthChartRender = () => {
  const [ready, setReady] = useState(false);

  const config =
    window.__DEPTH_CHART_CONFIG__ ||
    JSON.parse(sessionStorage.getItem("depthChartConfig") || "{}");
  const { positionMap = {}, headshotMap = {}, report = {} } = config;

  useEffect(() => {
    setReady(true);
  }, []);

  return (
    <div
      data-export-ready={ready ? "true" : undefined}
      data-chart-container
      className="bg-white"
      style={{ width: WIDTH, height: HEIGHT, overflow: "hidden", display: "flex", flexDirection: "column" }}
    >
      <div className="bg-gradient-to-r from-blue-800 to-blue-600 px-8 py-3 flex items-center gap-4 flex-shrink-0">
        {report.teamId && (
          <div className="w-10 h-10 rounded-xl overflow-hidden bg-white/10 ring-2 ring-white/20 flex-shrink-0">
            <img
              src={`${API_BASE_URL}/api/team-logo/${report.teamId}`}
              alt={report.teamName}
              className="w-full h-full object-contain p-1"
              onError={(e) => { e.currentTarget.style.display = "none"; }}
            />
          </div>
        )}
        <div>
          <div className="text-xl font-bold text-white">{report.teamName}</div>
          <div className="text-blue-200 text-xs mt-0.5">Depth Chart · {report.year}</div>
        </div>
      </div>

      <div style={{ flex: 1, minHeight: 0, padding: "0 32px" }}>
        <BaseballField positionMap={positionMap} headshotMap={headshotMap} interactive={false} />
      </div>

      <div className="text-center flex-shrink-0" style={{ padding: "4px 0" }}>
        <span className="text-gray-300 text-[9px]">
          Generated by D3 Dashboard · {new Date().toLocaleDateString()}
        </span>
      </div>
    </div>
  );
};
